"use strict";

var _slicedToArray = require("/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BrowserMetrics = void 0;

var SemanticMetrics_1 = require("../SemanticMetrics");

var Time_1 = require("../utils/Time");

function getNavigationTiming() {
  var _window$performance$g = window.performance.getEntriesByType('navigation'),
      _window$performance$g2 = _slicedToArray(_window$performance$g, 1),
      navigationTiming = _window$performance$g2[0];

  return navigationTiming;
}

function getResourceTiming() {
  return window.performance.getEntriesByType('resource');
}

function getPageLoadTime() {
  return new Promise(function (resolve, reject) {
    if (!window.performance || typeof performance.getEntriesByType !== 'function') {
      return reject('window.performance api is not supported in this browser');
    }

    if (typeof getNavigationTiming() === 'undefined') {
      return reject('navigationTiming api is not supported in this browser');
    }

    var _getNavigationTiming = getNavigationTiming(),
        loadEventEnd = _getNavigationTiming.loadEventEnd;

    if (loadEventEnd > 0) {
      return resolve(loadEventEnd);
    }

    return window.addEventListener('load', function () {
      setTimeout(function () {
        var _getNavigationTiming2 = getNavigationTiming(),
            nextLoadEventEnd = _getNavigationTiming2.loadEventEnd;

        return resolve(nextLoadEventEnd);
      }, 0);
    });
  });
}

function getPaintMetric(paintMetricName) {
  return new Promise(function (resolve, reject) {
    if (!window.performance || typeof performance.getEntriesByType !== 'function') {
      return reject('window.performance api is not supported in this browser');
    }

    return window.addEventListener('load', function () {
      var paintMetrics = performance.getEntriesByType('paint');
      var timeToPaintMetric = paintMetrics.find(function (_ref) {
        var name = _ref.name;
        return name === paintMetricName;
      });

      if (paintMetrics !== undefined && timeToPaintMetric) {
        return resolve(timeToPaintMetric.startTime);
      }

      return reject('Time to paint api is not supported on this browser');
    });
  });
}

function getTimeToFirstPaint() {
  return getPaintMetric('first-paint');
}

function getTimeToFirstContentfulPaint() {
  return getPaintMetric('first-contentful-paint');
}

function sendWebVitalsMetric(metric, tags) {
  return SemanticMetrics_1.sendMetric(getWebVitalsMetric(metric, tags));
}

function getWebVitalsMetric(_ref2, tags) {
  var name = _ref2.name,
      label = _ref2.label,
      vitalValue = _ref2.value;
  var metric;

  if (name.toLowerCase() === 'cls') {
    metric = {
      metric_type: 'gauge',
      value: vitalValue
    };
  } else {
    metric = {
      metric_type: 'timer',
      value: Time_1.Time.fromMillis(Math.round(vitalValue)).asNanos()
    };
  }

  return Object.assign(Object.assign({
    what: "web_vitals_".concat(name.toLowerCase())
  }, metric), {
    tags: Object.assign({
      name: name,
      label: label
    }, tags)
  });
}

var BrowserMetrics = {
  getPageLoadTime: getPageLoadTime,
  getResourceTiming: getResourceTiming,
  getTimeToFirstPaint: getTimeToFirstPaint,
  getTimeToFirstContentfulPaint: getTimeToFirstContentfulPaint,
  sendWebVitalsMetric: sendWebVitalsMetric,
  getWebVitalsMetric: getWebVitalsMetric
};
exports.BrowserMetrics = BrowserMetrics;